import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { ErrorCard } from "@/components/error-card";
import { parseError } from "@/lib/error-handler";
import { AppRoute } from "@/types/routes";

import { PaymentDetailsLayout } from "../components/payment-details-layout";
import { PaymentDetailsSkeleton } from "../components/payment-details-skeleton";

import type { PaymentDetailsView } from "../types";
import type { ActionableState } from "./use-actionable-state";
import type { CancelableState } from "./use-cancelable-state";

interface PaymentFetchViewProps {
  isLoading: boolean;
  error: unknown;
  view: PaymentDetailsView | null;
  actions?: ActionableState;
  cancel?: CancelableState;
}

export const PaymentFetchView = ({
  isLoading,
  error,
  view,
  actions,
  cancel,
}: PaymentFetchViewProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  if (isLoading) {
    return <PaymentDetailsSkeleton />;
  }

  if (error) {
    const { title, message } = parseError(error);
    return (
      <ErrorCard
        title={t(title)}
        message={t(message)}
        buttonLabel={t("home_claimButtonTitle")}
        onButtonClick={() => navigate(AppRoute.PAYMENTS)}
      />
    );
  }

  if (!view) {
    return (
      <ErrorCard
        title={t("error")}
        message={t("error_somethingWentWrong")}
        buttonLabel={t("home_claimButtonTitle")}
        onButtonClick={() => navigate(AppRoute.PAYMENTS)}
      />
    );
  }

  return (
    <PaymentDetailsLayout
      view={view}
      actions={actions}
      cancel={cancel}
      onChangePaymentMethod={() => navigate(AppRoute.PAYMENT_METHODS_LIST)}
    />
  );
};
